import React, { useState } from 'react';
import Canvas from './Canvas';
import StyleSelector from './StyleSelector';
import DataSelector from './DataSelector';
import { handwritingSamples } from './dataOptions';

function Handwriting() {
  const [selectedFont, setFont] = useState('Cursive');
  const [lineStyle, setLineStyle] = useState('none');
  const [sampleIndex, setSampleIndex] = useState(0);
  const [deviceType, setDeviceType] = useState('desktop');

  return (
    <div className="App">
      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="deviceType">Select Device: </label>
        <select
          id="deviceType"
          value={deviceType}
          onChange={(e) => setDeviceType(e.target.value)}
        >
          <option value="desktop">Desktop</option>
          <option value="mobile">Mobile</option>
        </select>
      </div>

      <StyleSelector setFont={setFont} setLineStyle={setLineStyle} />

      <Canvas
        selectedFont={selectedFont}
        lineStyle={lineStyle}
        sampleText={handwritingSamples[sampleIndex]}
        deviceType={deviceType}
      />
    </div>
  );
}

export default Handwriting;
